{
	"isGrouped": "Hay productos sin coste registrado",
	"isNotGrouped": "Coste no registrado",
	"na": "N/A"
}
